<template>
    <div class="scanner">
        <v-card v-if="$store.state.activeCheckpoint || $store.state.activeEvents.length || $store.state.activeZones.length"
                class="text-xs-center scanner-inner"
                :class="{'scanner-inner-novideo': !videoVisible}"
        >
            <v-container fluid v-if="test" class="header">
                <v-layout>
                    <v-flex>
                        <v-card-title primary-title class="pa-0">
                            <h3 class="headline mt-0 event-name">
                                {{$vuetify.t('$vuetify.menu.test')}}
                            </h3>
                        </v-card-title>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container fluid v-if="!test"
                         class="header"
                         :class="{'header-novideo': !videoVisible}"
            >
                <v-layout @click="videoVisible = !videoVisible">
                    <v-flex>
                        <v-card-title primary-title class="pa-0">
                            <h3 class="headline mt-0 event-name" v-html="activeEventNames"></h3>
                        </v-card-title>
                    </v-flex>
                </v-layout>

                <v-layout class="reader" v-if="readerCode!==''">
                    <span>
                        {{readerCode}}
                    </span>
                </v-layout>

                <v-layout class="footer">
                    <v-flex class="text-xs-left" v-if="getStartAt">
                        <div class="bg-left">
                            <b>{{ getStartAt | moment("D. M. HH:mm") }}</b>
                        </div>
                    </v-flex>
                    <v-flex class="text-xs-left" v-else>
                        &nbsp;
                    </v-flex>

                    <v-spacer></v-spacer>

                    <v-btn flat icon large class="manual-input"
                        @click="showManualDialog">
                        <v-icon large>keyboard</v-icon>
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-flex class="text-xs-right" v-if="$store.state.settings.showTicketCount">
                        <div class="bg-right" v-if="!loading">
                            <b>
                                <template v-if="!$store.state.activeCheckpoint">{{ getUsedTicketsCount }} / </template>
                                {{ getAllTicketsCount }}
                            </b>
                        </div>
                        <div class="bg-right" v-if="loading">
                            <b>{{$vuetify.t('$vuetify.scanner.loading')}}</b>
                        </div>
                    </v-flex>
                    <v-flex class="text-xs-right" v-else>
                        &nbsp;
                    </v-flex>
                </v-layout>
            </v-container>

            <QuaggaScanner
                v-if="!soundDialog && videoVisible"
                :onDetected="onDetected"
            />

            <div v-if="!videoVisible" :style="{height:'96px'}">
                &nbsp;
            </div>
        </v-card>

        <v-progress-linear class="mt-0 mb-0 progress-bar" :indeterminate="true" v-if="loading"></v-progress-linear>

        <v-card class="pl-3 pr-3 pt-3 pb-1 messages" v-if="$store.state.messages.length">
            <div
                v-for="(message, key) in $store.state.messages"
                :key="key"
                :class="message.type"
                class="message md-elevation-4"
            >
                <v-icon
                    class="checkmark"
                    v-if="message.type === 'success' && message.sent"
                >check</v-icon>

                <span v-html="message.message"></span>

                <div v-if="message.extra" class="text-xs-center">
                    <small v-html="message.extra" />
                </div>
            </div>
        </v-card>

        <v-dialog
                v-model="soundDialog"
                max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    <v-spacer></v-spacer>
                    {{$vuetify.t('$vuetify.scanner.startReader')}}
                    <v-spacer></v-spacer>
                </v-card-title>

                <v-card-text class="text-xs-center">
                    {{$vuetify.t('$vuetify.scanner.startReaderDescription')}}
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="green darken-1"
                            large block
                            @click="closeSoundDialog"
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="groupDialog"
                v-if="groupDialogTicket"
        >
            <v-card>
                <v-card-title
                        class="headline text-xs-center"
                        primary-title
                >
                    <v-spacer></v-spacer>
                    {{$vuetify.t('$vuetify.scanner.specialWarning')}}
                    <v-spacer></v-spacer>
                </v-card-title>

                <v-card-text class="text-xs-center">
                    <div class="display-1">
                        {{ groupDialogTicketset.customName ? groupDialogTicketset.customName : groupDialogTicketset.name }}
                    </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn
                            color="error"
                            flat large
                            @click="closeGroupDialog(false)"
                    >
                        {{$vuetify.t('$vuetify.scanner.refuse')}}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="success"
                            flat large
                            @click="closeGroupDialog(true)"
                    >
                        {{$vuetify.t('$vuetify.scanner.confirm')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="manualDialog"
                max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    <v-spacer></v-spacer>
                    {{$vuetify.t('$vuetify.scanner.manualTitle')}}
                    <v-spacer></v-spacer>
                </v-card-title>

                <v-card-text class="text-xs-center">
                    <v-form>
                        <v-text-field
                                ref="manualInput"
                                v-model="manualDialogVal"
                        />
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            :disabled="manualDialogVal.length<1"
                            color="green darken-1"
                            large block
                            @click="closeManualDialog"
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import QuaggaScanner from '../components/QuaggaScanner'
    import {initSound} from '../libs/utils'
    import {str2uia} from "../libs/nfc/crypto"
    import {LZString} from "@/libs/nfc/lz-string";

    export default {
        props: {
            test: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                soundDialog: false,
                groupDialog: false,
                timer: null,
                loading: false,
                groupDialogTicket: null,
                groupDialogTicketset: null,
                groupDialogOnline: null,
                manualDialog: false,
                manualDialogVal: '',
                clearTicketTimer: null,
                tempCode: [],
                resizeY: 0,
                resizeActive: false,
                resizeStartY: this.$store.state.settings.videoHeight,
                readerCode: '',
                videoVisible: this.$store.state.settings.camera !== '-',
                torchAvailable: false,
                torchEnabled: false,
                abortController: null
            }
        },

        components: {
            QuaggaScanner
            // HelloWorld
        },

        computed: {
            getUsedTicketsCount() {
                if (this.$store.state.tickets.length) {
                    return this.$store.state.tickets.reduce((acc, ticketset) => {
                        return acc + ticketset.list.filter(ticket => ticket.used).length
                    }, 0)
                }
                return 0
            },
            getAllTicketsCount() {
                if (this.$store.state.tickets.length) {
                    return this.$store.state.tickets.reduce((acc, ticketset) => {
                        return acc + ticketset.list.length
                    }, 0)
                }
                return 0
            },

            activeEventNames() {
                if (this.$store.state.activeCheckpoint) {
                    return `Kontrolní místo: ${this.$store.getters.activeCheckpointObject.name}`
                } else if (this.$store.state.activeZones.length) {
                    const zones = this.$store.state.activeZones.map(
                        zoneId => this.$store.state.zones.find(zone => parseInt(zone.id) === zoneId).name
                    ).join(', ')
                    return `Zóny: ${zones}`
                } else {
                    const str = this.$store.state.activeEvents.map(event => this.$store.getters['eventById'](event).name).join(', ')
                    if (str.length > 32) {
                        return '...více akcí...'
                    } else {
                        return str
                    }
                }
            },

            getStartAt() {
                if (this.$store.state.activeEvents.length) {
                    return this.$store.state.activeEvents[0].startAt
                }
                return ''
            }
        },

        created() {
            let AudioContext = window.AudioContext || window.webkitAudioContext || false
            if (AudioContext) {
                let context = new AudioContext()
                if (context && context.state !== 'running') {
                    this.soundDialog = true
                }
            }

            if (this.$store.state.settings.nfc) {
                this.initNfc()
            }

            this.$store.commit('clearMessages')
            this.$store.commit('setLastCode', '')

            if (!this.test) {
                const ticketTicketsets = this.$store.state.tickets.map(ticketset => ticketset.id)

                let selectedTicketsets = []
                if (this.$store.state.activeCheckpoint) {
                    const cp = this.$store.state.checkpoints.find(cp => cp.id === this.$store.state.activeCheckpoint)
                    selectedTicketsets = cp.ticketsets.reduce((acc, ticketset) => {
                        if (ticketset.selected) {
                            return [...acc, parseInt(ticketset.id)]
                        }
                        return acc
                    }, [])

                } else if (this.$store.state.activeZones.length) {
                    // pass

                } else {
                    selectedTicketsets = this.$store.state.events.reduce((acc1, event) => {
                        return event.ticketsets.reduce((acc2, ticketset) => {
                            if (ticketset.selected) {
                                return [...acc2, parseInt(ticketset.id)]
                            }
                            return acc2
                        }, acc1)
                    }, [])
                }

                if (this.$store.state.activeZones.length) {
                    if (this.$store.state.lastZones === null
                        || this.$store.state.lastZones !== JSON.stringify(this.$store.state.activeZones)
                        || new Date(this.$store.state.lastZoneLoadDate) < new Date(new Date().getTime() - 1000 * 60 * 60 * 24)
                    ) {
                        console.log('+++ LOADING', this.$store.state.lastZones, this.$store.state.lastZoneLoadDate)

                        this.$store.commit('clearTickets')
                        this.$store.dispatch('loadZones')

                        this.loading = true
                        this.$store.dispatch('loadTicketsZones')
                            .then(() => {
                                this.$store.commit('setLastZones', JSON.stringify(this.$store.state.activeZones))
                                this.$store.commit('setLastZoneLoadDate', new Date().toISOString())

                                this.loading = false
                                this.$store.dispatch('updateLoopStart')
                            })
                    } else {
                        console.log('--- NOT LOADING', this.$store.state.lastZones, this.$store.state.lastZoneLoadDate)
                        this.$store.dispatch('updateLoopStart')
                    }

                } else {
                    const same = (ticketTicketsets.sort().join(',') === selectedTicketsets.sort().join(','))
                    if (!same) {
                        this.$store.commit('clearTickets')

                        this.loading = true
                        this.$store.dispatch('loadTickets', selectedTicketsets)
                            .then(() => {
                                this.loading = false
                                this.$store.dispatch('updateLoopStart')
                            })

                    } else {
                        this.$store.dispatch('updateLoopStart')
                    }
                }
            }

            window.addEventListener('keydown', this.onKey)
        },

        beforeDestroy () {
            if (this.$store.state.settings.nfc) {
                this.abortController.abort()
            }

            window.removeEventListener('keydown', this.onKey)
            if (!this.test) {
                this.$store.dispatch('updateLoopStop')
            }
        },

        methods: {
            onKey(event) {
                // Numbers
                if (event.keyCode >= 48 && event.keyCode <= 57 && !this.manualDialog) {
                    this.readerCode += event.key
                }
                // letters
                if (event.keyCode >= 65 && event.keyCode <= 90 && !this.manualDialog) {
                    this.readerCode += event.key
                }

                if (event.keyCode === 8) {
                    this.readerCode = this.readerCode.substr(0, this.readerCode.length - 1)
                }
                if (event.keyCode === 13 || event.keyCode === 190) {
                    this.processCode(this.readerCode, true)
                    this.readerCode = ''
                }
            },

            ticketUse(ticketsetId, code, isOnline) {
                let payload = {
                    ticketsetId: parseInt(ticketsetId),
                    code: code,
                    isOnline: isOnline
                }
                if (this.$store.state.activeCheckpoint) {
                    payload.checkpoint = parseInt(this.$store.state.activeCheckpoint)
                }
                if (this.$store.state.activeZones.length) {
                    payload.zoneIds = this.$store.state.activeZones
                }

                this.$store.dispatch('ticketUse', payload)
                    .then((data) => {
                        console.log('ticketUse', data)
                        if (data.ok || data === false) {
                            let message
                            if (this.$store.state.settings.group === 'ticketset' ||
                                this.$store.state.settings.group === 'block'
                            ) {
                                const ticketset = this.$store.getters['activeTicketsetById'](ticketsetId)
                                message = this.$vuetify.t('$vuetify.scanner.messageSuccessTicketset', code, ticketset.name)

                            } else if (this.$store.state.settings.group === 'price') {
                                const [ticket, _] = this.$store.getters['getTicketByCode'](code)
                                message = this.$vuetify.t(
                                    '$vuetify.scanner.messageSuccessPrice',
                                    code,
                                    ticket.price ? ticket.price.name : ''
                                )

                            } else if (this.$store.state.settings.group === 'ticketset_price') {
                                const ticketset = this.$store.getters['activeTicketsetById'](ticketsetId)
                                const [ticket, _] = this.$store.getters['getTicketByCode'](code)
                                message = this.$vuetify.t(
                                    '$vuetify.scanner.messageSuccessTicketsetPrice',
                                    code,
                                    ticketset.name,
                                    ticket.price ? ticket.price.name : ''
                                )

                            } else if (this.$store.state.settings.group === 'event') {
                                const ticketset = this.$store.getters['activeTicketsetById'](ticketsetId)
                                let event = this.$store.getters['activeEventByTicketsetId'](ticketsetId)
                                if (event === null) {
                                    event = {name:'---'}
                                }
                                message = this.$vuetify.t(
                                    '$vuetify.scanner.messageSuccessEvent',
                                    code, event.name, ticketset.name
                                )

                            } else {
                                message = this.$vuetify.t('$vuetify.scanner.messageSuccess', code)
                            }

                            this.$store.commit('addMessage', {
                                type: 'success',
                                ticketsetId: ticketsetId,
                                code: code,
                                message: message
                            })
                            if (this.$store.state.settings.sound && this.$store.$sound.ok) {
                                this.$store.$sound.ok.play()
                            }

                        } else {
                            // let msg = ''
                            // let extra = ''
                            // switch(data.message) {
                            //     case 'CODE_DOES_NOT_EXISTS':
                            //         msg = this.$vuetify.t('$vuetify.scanner.messageNotFound', code)
                            //         break
                            //     case 'TICKET_SLOT_NOT_ACTIVE':
                            //         msg = this.$vuetify.t('$vuetify.scanner.messageBadSlot', code)
                            //         break
                            //     default:
                            //         msg = this.$vuetify.t('$vuetify.scanner.messageUsed', code)
                            //         const useDate = new Date(data.usedAt).toLocaleString()
                            //         const usedByName = data.usedBy
                            //         extra = this.$vuetify.t('$vuetify.scanner.messageExtra1', usedByName, useDate)
                            // }

                            const msg = this.$vuetify.t('$vuetify.scanner.messageNotUsable', code)
                            const extra = data.display

                            this.$store.commit('addMessage', {
                                type: 'used',
                                message: msg,
                                extra: extra
                            })
                            if (this.$store.state.settings.sound && this.$store.$sound.alarm) {
                                this.$store.$sound.alarm.play()
                            }
                        }
                    })
            },

            processCode (code, noValidate = false) {
                let ticket, ticketset
                if (!this.test) {
                    [ticket, ticketset] = this.$store.getters.getTicketByCode(code)
                }

                if (!this.test && ticket === null) {
                    if (this.tempCode.length<2 && !noValidate) {
                        this.tempCode.push(code)
                        if (this.tempCode.length > 2) {
                            this.tempCode.shift()
                        }
                        return
                    } else if ((code !== this.tempCode[0] || code !== this.tempCode[1]) && !noValidate) {
                        this.tempCode.push(code)
                        if (this.tempCode.length > 2) {
                            this.tempCode.shift()
                        }
                        return
                    }
                }

                this.tempCode = []

                if (this.test) {
                    if (code !== this.$store.state.lastCode) {
                        this.$store.commit('addMessage', {
                            type: 'success',
                            message: this.$vuetify.t('$vuetify.scanner.messageRead', code)
                        })
                        if (this.$store.state.settings.sound && this.$store.$sound.ok) {
                            this.$store.$sound.ok.play()
                        }
                        this.$store.commit('setLastCode', code)
                        setTimeout(() => {
                            this.$store.commit('setLastCode', '')
                        }, 1000)
                    }
                } else {
                    if (code !== this.$store.state.lastCode) {
                        if (ticket) {
                            const subUse = (isOnline) => {
                                // 1803120527605
                                let full_ticketset = this.$store.getters['activeTicketsetById'](ticketset.id)
                                if (full_ticketset.validate) {
                                    if (this.$store.state.settings.sound && this.$store.$sound.alarm) {
                                        this.$store.$sound.check.play()
                                    }
                                    this.groupDialogTicket = ticket
                                    this.groupDialogTicketset = full_ticketset
                                    this.groupDialogOnline = true
                                    this.groupDialog = true
                                } else {
                                    this.ticketUse(full_ticketset.id, code, isOnline)
                                }
                            }

                            if (ticket.isOnline || this.$store.state.activeCheckpoint) {
                                subUse(true)

                            } else if (ticket.used) {
                                let usedByName = 'neznámé'
                                if (ticket.usedBy && ticket.usedBy.name) {
                                    usedByName = ticket.usedBy.name
                                }
                                const useDate = new Date(ticket.usedAt).toLocaleString()
                                const extra = this.$vuetify.t('$vuetify.scanner.messageExtra1', usedByName, useDate)

                                this.$store.commit('addMessage', {
                                    type: 'used',
                                    message: this.$vuetify.t('$vuetify.scanner.messageUsed', code),
                                    extra: extra
                                })
                                if (this.$store.state.settings.sound && this.$store.$sound.alarm) {
                                    this.$store.$sound.alarm.play()
                                }

                            } else if (this.$store.state.sendQueue.find(c => {
                                const shortLen = Math.min(c.code.length, code.length)
                                const tc = c.code.substr(0, shortLen)
                                const cc = code.substr(0, shortLen)
                                return tc === cc && c.ticketsetId.toString() === ticketset.id.toString()
                            })) {
                                this.$store.commit('addMessage', {
                                    type: 'used',
                                    message: this.$vuetify.t('$vuetify.scanner.messageUnsend', code)
                                })
                                if (this.$store.state.settings.sound && this.$store.$sound.alarm) {
                                    this.$store.$sound.alarm.play()
                                }

                            } else {
                                subUse(false)
                            }

                        } else {
                            // let payload = {
                            //     code: code,
                            // }
                            // if (this.$store.state.activeCheckpoint) {
                            //     payload.checkpoint = parseInt(this.$store.state.activeCheckpoint)
                            // }
                            // if (this.$store.state.activeZones.length) {
                            //     payload.zoneIds = this.$store.state.activeZones
                            // }
                            // this.$store.dispatch('ticketDirectUse', payload)
                            //     .then((data) => {
                            //         console.log('ticketDirectUse', data)
                            //     })

                            this.$store.dispatch('ticketInfo', code)
                                .then((data) => {
                                    this.$store.commit('addMessage', {
                                        type: 'not-found',
                                        message: this.$vuetify.t('$vuetify.scanner.messageNotFound', code),
                                        extra: data
                                    })
                                    if (this.$store.state.settings.sound && this.$store.$sound.alarm) {
                                        this.$store.$sound.alarm.play()
                                    }
                                })
                        }

                        this.$store.commit('setLastCode', code)

                        clearTimeout(this.clearTicketTimer)
                        this.clearTicketTimer = setTimeout(() => {
                            this.$store.commit('setLastCode', '')
                        }, 5000)
                    }
                }
            },

            onDetected (result) {
                this.processCode(result)
            },

            closeSoundDialog() {
                initSound(this.$store)
                this.soundDialog = false
            },

            closeGroupDialog(success) {
                if (success) {
                    this.ticketUse(this.groupDialogTicketset.id, this.groupDialogTicket.code, this.groupDialogOnline)
                } else {
                    this.$store.commit('setLastCode', '')
                }
                this.groupDialog = false
            },

            showManualDialog() {
                this.manualDialog = true
                this.manualDialogVal = ''

                setTimeout(() => {
                    this.$refs.manualInput.focus()
                }, 200)
            },

            closeManualDialog() {
                this.manualDialog = false
                this.processCode(this.manualDialogVal, true)
            },

            dragStart(e) {
                if (e instanceof TouchEvent) {
                    this.resizeY = e.touches[0].pageY
                } else {
                    this.resizeY = e.pageY
                }
                this.resizeActive = true
                this.resizeStartY = this.$store.state.settings.videoHeight
            },
            dragEnd() {
                this.resizeActive = false
            },
            dragMove(e) {
                if (this.resizeActive) {
                    let posY = e.pageY
                    if (e instanceof TouchEvent) {
                        posY = e.touches[0].pageY
                    }
                    let offs = posY - this.resizeY

                    this.$store.commit('setSettingsVideoHeight', this.resizeStartY + offs)
                }
            },

            changeTorchAvailable (val) {
                this.torchAvailable = val
            },

            async initNfc() {
                const _$store = this.$store
                const _this = this

                const nfcAvailable = 'NDEFReader' in window
                if (!nfcAvailable) {
                    console.log('NFC Not Available')
                } else {
                    const publicKeyToBeImported = {
                        "crv": "P-256",
                        "ext": true,
                        "key_ops": ["verify"],
                        "kty": "EC",
                        "x": "E5rmr-qxtlE8nj1_n9ypycmrI9CM6EOQd_bWYhQys5I",
                        "y": "9oPL9RWzsY0mQFpTwVL1XT1mqn-CCti-xavPcW-C-ik"
                    }
                    const sc = window.crypto.subtle
                    const keyAlgorithm = { name: 'ECDSA', namedCurve: 'P-256' };
                    const sigAlgorithm = { name: 'ECDSA', hash: { name: 'SHA-256' }};

                    const publicKey = await sc.importKey('jwk', publicKeyToBeImported, keyAlgorithm,
                        true, ['verify'])

                    const nfc = new NDEFReader()
                    this.abortController = new AbortController()

                    function decompressFromUint8Array(uint8Array) {
                        if (uint8Array.length === 0) return [];

                        let array = LZString.decompressFromUint8Array(uint8Array).split(',').map(Number);

                        for (let i=1; i < array.length; i++) {
                            array[i] += array[i - 1];
                        }

                        return array;
                    }

                    function nfcScanData(nfc, abortController, callback) {
                        nfc.scan({signal: abortController.signal}).then(() => {
                            console.log("Scan started successfully")

                            nfc.onreadingerror = event => {
                                console.log("Cannot read data from the tag")
                            }

                            nfc.onreading = event => {
                                callback(event.serialNumber, event.message.records)
                            }
                        }).catch(error => {
                            console.log("Scan failed to start: " + error)
                        })
                    }

                    async function handleData(serialNumber, records, publicKey) {
                        let header = null

                        console.log('Tag serial number: ' + serialNumber)

                        if (records.length === 0) {
                            throw 'No tickets data read - try again'
                        }

                        for (const record of records) {
                            console.log("Record id: " + record.id + "\nRecord type: " + record.recordType +
                                "\nMIME type: " + record.mediaType)

                            if (record.recordType === "mime") {
                                let ticket, ticketset, processed = false

                                switch(record.mediaType) {
                                    case 'application/json':
                                        const decoder = record.encoding ?
                                            new TextDecoder(record.encoding) : new TextDecoder()

                                        // očekáváno: { "bz": 1, "mail": "jan.novak@kdovikde.cz", "sig": "digitální-podpis" }
                                        header = JSON.parse(decoder.decode(record.data))

                                        if (header.bz !== 1) throw 'Unsupported version of data: ' + header.bz
                                        if (!header.mail) throw 'Data header does not contain the e-mail'
                                        if (!header.sig) throw 'Data header does not contain the digital signature'
                                        break

                                    case 'application/octet-stream':
                                        if (!header) {
                                            throw 'Header not found - cannot verify data!'
                                        }

                                        let compressed = new Uint8Array(record.data.buffer)
                                        let dataToVerify = new Uint8Array([
                                            ...str2uia(serialNumber),
                                            ...str2uia(header.mail),
                                            ...compressed
                                        ])

                                        if (!await sc.verify(sigAlgorithm, publicKey,
                                            str2uia(header.sig), dataToVerify)
                                        ) {
                                            throw 'Digital signature of data does not match'
                                        }

                                        let decompressed = decompressFromUint8Array(compressed)

                                        console.log('decompressed.length = ' + decompressed.length)
                                        console.log(decompressed)

                                        for (let i=0; i<decompressed.length; i++) {
                                            const code = decompressed[i].toString();

                                            [ticket, ticketset] = _$store.getters.getTicketByCode(code)
                                            if (ticket && ticketset) {
                                                _this.processCode(code)
                                                processed = true
                                                break
                                            }
                                        }

                                        if (!processed) {
                                            _this.$store.commit('addMessage', {
                                                type: 'not-found',
                                                message: _this.$vuetify.t('$vuetify.scanner.nfcNotFound')
                                            })
                                            if (_this.$store.state.settings.sound && _this.$store.$sound.alarm) {
                                                _this.$store.$sound.alarm.play()
                                            }
                                        }
                                        break

                                    default:
                                        console.log('Unhandled MIME type: ' + record.mediaType)
                                }
                            } else
                                console.log('Unhandled record type: ' + record.recordType)
                        }
                    }

                    nfcScanData(nfc, this.abortController, function(serialNumber, records) {
                        handleData(serialNumber, records, publicKey).catch(error => {
                            console.log(error)
                        })
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .scanner {
        h2 {
            margin-top: 0;
        }

        .stats {
            float: right;
        }

        .messages {
            margin-top: 10px;
        }

        .message {
            padding: 5px 10px;
            margin-bottom: 10px;
            text-align: center;

            span {
                &::v-deep big {
                    font-size: 200%;
                }
            }
        }

        .checkmark {
            float: left;
            margin-top: -2px;
            margin-left: -5px;
        }

        .used {
            background-color: red;
            color: white;
        }
        .success {
            background-color: darkgreen;
            color: white;
        }
        .not-found {
            background-color: darkorange;
            color: black;
        }

        .scanner-inner {
            background: #212121;
            margin: -16px;
            margin-top: -64px;
        }
        .scanner-inner-novideo {
            background: none;
            margin: -16px;
            margin-top: -8px;
            box-shadow: none;
        }
    }

    .header {
        position: absolute;
        z-index: 1;
        top: 48px;
        /*border: 1px solid red;*/
        height: calc(100% - 48px);

        .event-name {
            text-align: center;
            font-size: 18px !important;
            margin: 0 auto;
            background: rgba(0,0,0,0.3);
            border-radius: 10px;
            padding: 3px 10px;
        }

        .footer {
            position: absolute;
            bottom: 5px;
            font-size: 16px;
            width: calc(100% - 32px);

            align-items: center;
            justify-content: center;

            .bg-left {
                display: inline-block;
                margin-left: -16px;
                background: rgba(0,0,0,0.4);
                border-top-right-radius: 10px;
                border-bottom-right-radius: 10px;
                padding: 3px 10px 3px 26px;
            }

            .bg-right {
                display: inline-block;
                margin-right: -16px;
                background: rgba(0,0,0,0.4);
                border-top-left-radius: 10px;
                border-bottom-left-radius: 10px;
                padding: 3px 26px 3px 10px;
            }
        }

        .reader {
            position: absolute;
            bottom: 52px;
            width: calc(100% - 32px);
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            letter-spacing: 2px;
            align-items: center;
            justify-content: center;

            span {
                display: inline-block;
                background: rgba(0,0,0,0.4);
                padding: 3px 10px 3px 10px;
            }
        }

        &-novideo {
            top: 48px;

            .event-name {
                position: relative;
                top: -56px;
                margin: 0;
                width: 100%;
            }
        }
    }

    .manual-input {
        margin: 0;
    }

    .progress-bar {
        margin-left: -16px;
        margin-right: -16px;
        top: 11px;
        width: 100vw;
    }
</style>
